import React from "react";
import { handleDay } from "@/utils/helper";
import { Input } from "@material-tailwind/react";
import { AiOutlineSearch } from "react-icons/ai";

interface Props {
  startDate: string;
  endDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
  onChangeFunc: (event: React.ChangeEvent<HTMLInputElement>) => void;
  nameInput: string;
  dataInput: string;
  placeHolder: string;
  searchFunc: () => void;
}

const SearchComponents: React.FC<Props> = ({
  endDate,
  setEndDate,
  startDate,
  setStartDate,
  nameInput,
  onChangeFunc,
  dataInput,
  placeHolder,
  searchFunc
}: Props) => {
  return (
    <div className="list-query">
      <div className="list-query__search w-1/4">
        <p className="text-sm">{nameInput}</p>
        <Input
          variant="static"
          placeholder={placeHolder}
          color="gray"
          type="text"
          value={dataInput}
          onChange={(e) => onChangeFunc(e)}
        />
      </div>
      <div className="list-query__search w-1/4">
        <p className="text-sm">Từ Ngày</p>
        <Input
          variant="static"
          color="gray"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(handleDay(e.target.value))}
        />
      </div>
      <div className="list-query__search w-1/4">
        <p className="text-sm">Đến Ngày</p>
        <Input
          variant="static"
          color="gray"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(handleDay(e.target.value))}
        />
      </div>
      <div className="list-query__search flex justify-center">
        <button className="check-another-activated" onClick={searchFunc}>
          <AiOutlineSearch />
          <span>Tìm Kiếm</span>
        </button>
      </div>
    </div>
  );
};

export default SearchComponents;
